// eslint-disable-next-line import/prefer-default-export
export const camelToSnake = (string) => string.replace(/[\w]([A-Z])/g, (m) => `${m[0]}_${m[1]}`).toLowerCase();
